import { useSearchParams } from "react-router-dom";

/**
 * Hook to extract list ID from URL search params
 * Returns null for special lists (__all__, __favorites__) or when no list is specified
 * 
 * @returns The list ID from URL, or null if it's a special list or not specified
 * 
 * @example
 * // URL: /items?list=abc123
 * const listId = useListIdFromUrl(); // "abc123"
 * 
 * // URL: /items?list=__all__
 * const listId = useListIdFromUrl(); // null
 */
export function useListIdFromUrl(): string | null {
  const [searchParams] = useSearchParams();
  const listIdFromUrl = searchParams.get("list");
  
  // Return null for special lists (all, favorites) or when no list is specified
  if (!listIdFromUrl || listIdFromUrl === "__all__" || listIdFromUrl === "__favorites__") {
    return null;
  }
  
  return listIdFromUrl;
}
